"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc");

// @ts-ignore no module typings
var schema = (0, _reactDesc.describe)({
  displayName: 'BrandInfo'
});
schema.propTypes = {
  logo: _reactDesc.PropTypes.string.description('A logo to be displayed. Should be a url (or equivalent). Used as `<img src={logo} />`.'),
  primaryText: _reactDesc.PropTypes.string.description('A prominent text').isRequired,
  secondaryText: _reactDesc.PropTypes.string.description('A less prominent text')
};
schema.defaultProps = {
  logo: undefined
};
var _default = schema;
exports.default = _default;